export default {
  path: 'recommendations',
  component: () => import(/* webpackChunkName: "financial-predictions-recommendations" */ './Recommendations'),
  meta: { requiresAuth: true }
}
